// LoadingSpinner.tsx
import React from 'react'

const LoadingSpinner: React.FC = () => (
    <div className='mt-10'>
        <div className='flex justify-center items-center'>
            <div
                style={{
                    borderColor: 'black',
                    borderTopColor: 'transparent',
                    animation: 'spin 1s linear infinite',
                    borderWidth: '4px',
                    borderStyle: 'solid',
                    borderRadius: '50%',
                    width: '100px',
                    height: '100px',
                }}
            ></div>
            <style>
                {`
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `}
            </style>
        </div>
    </div>
)

export default LoadingSpinner
